import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DownloadIndicatorComponent } from '@shared/components/download-indicator/download-indicator.component';
import { ApiMaestrosService } from '@core/api/services/maestros/api-maestros.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { HttpEvent } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DownloadIndicatorService {
  constructor(
    private masterApi: ApiMaestrosService,
    private snackbar: MatSnackBar,
    private translate: TranslateService
  ) {}

  downloadDocument(idDCTM: string, filename: string) {
    this.download(this.masterApi.downloadDocumentWithProgress(idDCTM), filename);
  }

  downloadDocuments(idDCTMs: Array<string>, filename: string) {
    this.download(this.masterApi.downloadDocumentsWithProgress(idDCTMs), filename);
  }

  download(obs: Observable<HttpEvent<Blob>>, filename: string) {
    this.snackbar.openFromComponent(DownloadIndicatorComponent, {
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
      panelClass: 'ac-download-snackbar',
      announcementMessage: `${this.translate.instant('GENERAL.DOWNLOADING')} ${filename}`,
      data: {
        obs,
        filename,
      },
    });
  }
}
